import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';

export interface LoaderFlagState {
    flag: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class ButtonService {

    private loaderFlag = new BehaviorSubject<LoaderFlagState>({flag: false});
    loaderFlagState = this.loaderFlag.asObservable();
    constructor() { }

    handleButtonLoaderFlag(loaderFlagState: LoaderFlagState) {
        this.loaderFlag.next(loaderFlagState);
        
    }
    
}
